import { getToken } from '@config/firebase';
import { useEffect } from 'react';

const Notifications = (): JSX.Element => {
  useEffect(() => {
    void getToken();
  }, []);

  return <></>;
};

export default Notifications;
